export function Brand({ dark = false, iconSize = 32, textClass = "text-xl", style, showText = true, className = "" }) {
  return (
    <span className={`flex items-center gap-2 ${className}`}>
      <img
        src="/recoveros-icon.png"
        alt="RecoverOS"
        style={{ height: iconSize, width: iconSize }}
        className="object-contain shrink-0"
        data-testid="brand-logo-icon"
      />
      {showText && (
        <span className={`font-extrabold tracking-tight ${textClass}`} style={style}>
          <span className={dark ? "text-white" : "text-slate-900"}>Recover</span>
          <span style={{ color: "#22c55e" }}>OS</span>
        </span>
      )}
    </span>
  );
}
